<template>
<admin-template subtitle="Jobs" headerButton="Create Job"
  @onButtonClicked="onCreateJob">
<sidebar-modal :active.sync="showSidebar" :title="sidebarTitle"
  :loading="sidebarLoading" :button="sidebarButton"
  :destroyLoading='destroyLoading'
  :destructive="destructiveButton"
  v-on:action="onSidebarAction"
  v-on:destroy="onSidebarDestroy"
               :isAi="true"
  :error.sync="sidebarError">
  <banner :active.sync="bannerActive" :title="jobError" :error="jobError" :time=2000 />
  <component v-bind:is="sidebarComponent" :isCreate="isCreate" v-if="showSidebar"></component>
</sidebar-modal>
<dropdown-modal :active.sync="dropdownActive" :title="dropdownTitle">
  <p>Are you sure you want to remove this job?</p>
  <div class="modal-buttons">
    <button class="button is-primary" @click="cancelRemove">No</button>
    <button class="button is-danger" @click="confirmRemove">Yes</button>
  </div>
</dropdown-modal>
  <admin-jobs-nav v-if="isJobBoardOwner" :active="active" v-on:active="handleTab" ></admin-jobs-nav>
<div v-if="!isJobBoardOwner">

  <div class="is-grouped columns is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd" >
    <div class="column"></div>
    <div class="column"></div>
    <div class="column">
      <p class="control is-expanded has-icons-left">
        <input v-model="formSearchJob" class="input" type="text" placeholder="Keyword">
        <span class="icon is-small is-left">
                <i class="fas fa-search"></i>
              </span>
      </p>
    </div>
  </div>
</div>
  <div v-if="active === 'My Jobs'" class="jobs">
  <div v-if="jobs.length > 0 && !jobsLoading">
    <job-row-card class="job" v-for="job in filterJobs" :key="job.id" :job="job"
    @click="onJobSelect(job)">
    </job-row-card>
  </div>
  <row-skeleton :right="true" v-else-if="jobsLoading"></row-skeleton>
  <empty-state v-else title="No Jobs" icon='empty-state-eyes'>
    <template slot="content">
      No jobs to see here. Let’s create a new job! It’s free to post a job ad. We’re here to help if you need support. Chat with us by clicking the green widget bottom right.
    </template>
  </empty-state>
</div>
  <div v-if="active === 'My Board'" class="jobs">
    <div v-if="myBoardJobs.length > 0 && !myBoardJobsLoading">
      <job-row-card class="job" v-for="job in myBoardJobs" :key="job.id" :job="job" >
      </job-row-card>
    </div>
    <row-skeleton :right="true" v-else-if="myBoardJobsLoading"></row-skeleton>
    <empty-state v-else title="No Jobs" icon='empty-state-eyes'>
      <template slot="content">
        No jobs to see here. Let’s create a new job! It’s free to post a job ad. We’re here to help if you need support. Chat with us by clicking the green widget bottom right.
      </template>
    </empty-state>
  </div>
</admin-template>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import AdminTemplate from './admin-sub'
import JobRowCard from '@/components/jobs/job-row-card'
import CreateJobForm from '@/components/admin/jobs/create-job-form'
import SidebarModal from '@/components/sidebar-modal'
import DropdownModal from '@/components/dropdown-modal'
import EmptyState from '@/components/general/empty-state'
import RowSkeleton from '@/components/general/row-skeleton'
import AdminJobsNav from '../../components/admin/jobs/admin-jobs-nav'
import Banner from '@/components/general/banner'

const EditJobForm = CreateJobForm

export default {
  components: {
    RowSkeleton,
    AdminTemplate,
    JobRowCard,
    CreateJobForm,
    SidebarModal,
    EditJobForm,
    DropdownModal,
    EmptyState,
    AdminJobsNav,
    Banner
  },
  computed: {
    ...mapState('adminJobs', [
      'jobs', 'jobsLoading', 'myBoardJobs', 'myBoardJobsLoading', 'searchJob'
    ]),
    ...mapState('jobs', ['createJobTrigger']),
    ...mapState('users', ['user']),
    isJobBoardOwner () {
      return this.user && this.user.profile === 'jobboardowner'
    },
    formSearchJob: {
      get () { return this.searchJob },
      set (value) { this.setSearchJob(value) }
    },
    filterJobs () {
      if (this.searchJob) {
        return this.jobs.filter(job => {
          return this.searchJob && ((job.companyName && job.companyName.toLowerCase().includes(this.searchJob.toLowerCase())) || (job.title && job.title.toLowerCase().includes(this.searchJob.toLowerCase())))
        })
      } else {
        return this.jobs
      }
    }
  },
  methods: {
    ...mapActions('adminJobs', [
      'getAllJobs', 'getMyBoardJobs'
    ]),
    ...mapActions('jobs', [
      'getJobTags'
    ]),
    ...mapActions('jobForm', [
      'createJob',
      'updateJob',
      'removeJob'
    ]),
    ...mapActions('domain', ['fetchJobTypesRewards', 'fetchJobTypes']),
    ...mapMutations('adminJobs', ['setSearchJob']),
    ...mapMutations('jobForm', {
      clearJobForm: 'clear',
      loadFormWithJob: 'loadWithJob'
    }),
    onCreateJob () {
      this.sidebarLoading = false
      this.sidebarButton = 'Create Job'
      this.showSidebar = true
      this.sidebarComponent = 'CreateJobForm'
      this.sidebarTitle = 'New job'
      this.isCreate = true
    },
    onJobSelect (job) {
      this.clearJobForm()
      this.loadFormWithJob(job)
      this.sidebarLoading = false
      this.sidebarButton = 'Save Job'
      this.destructiveButton = 'Delete Job'
      this.sidebarComponent = 'EditJobForm'
      this.sidebarTitle = 'Edit job'
      this.showSidebar = true
      this.isCreate = false
    },
    async onSidebarAction () {
      if (this.sidebarLoading || this.destroyLoading) { return }
      this.sidebarError = null
      switch (this.sidebarComponent) {
        case 'CreateJobForm': {
          this.sidebarLoading = true
          try {
            await this.createJob()
            this.showSidebar = false
            this.clearJobForm()
          } catch (error) {
            this.sidebarError = error.message
          }
          this.sidebarLoading = false
          break
        }
        case 'EditJobForm': {
          this.sidebarLoading = true
          try {
            await this.updateJob()
            this.showSidebar = false
            this.clearJobForm()
          } catch (error) {
            this.sidebarError = error.message
          }
          this.sidebarLoading = false
          break
        }
        default: break
      }
    },
    async onSidebarDestroy () {
      switch (this.sidebarComponent) {
        case 'EditJobForm': {
          this.dropdownTitle = 'Remove Job?'
          this.dropdownActive = true
        }
      }
    },
    cancelRemove () {
      this.showDropdown = false
    },
    async confirmRemove () {
      try {
        this.dropdownActive = false
        this.destroyLoading = true
        await this.removeJob()
        this.destroyLoading = false
        this.showSidebar = false
      } catch (e) {
        this.destroyLoading = false
        this.bannerActive = true
        this.jobError = e.message
      }
    },
    handleTab (activeTab) {
      this.active = activeTab
    }
  },
  mounted () {
    this.fetchJobTypesRewards()
    this.fetchJobTypes()
    this.getAllJobs()
    this.getJobTags()
    if (this.isJobBoardOwner) {
      this.getMyBoardJobs()
    }
    if (this.$route.name === 'AdminCreateJobs') {
      this.onCreateJob()
    }
  },
  watch: {
    createJobTrigger () {
      this.onCreateJob()
    }
  },

  data () {
    return {
      sidebarTitle: '',
      sidebarComponent: '',
      showSidebar: false,
      sidebarLoading: false,
      sidebarButton: '',
      destructiveButton: '',
      dropdownActive: false,
      dropdownTitle: '',
      destroyLoading: false,
      sidebarError: null,
      active: 'My Jobs',
      jobError: null,
      bannerActive: false,
      isCreate: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.jobs {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.job:hover {
  cursor: pointer;
  background-color: $hover-background;
}

.job:not(:first-child) {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.job:not(:last-child) {
  border-bottom: 0;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

div.modal-buttons {
  display: flex;
  flex-grow: 1;
  .button {
    flex-grow: 1;
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
  justify-content: space-around;
}

.w-25{
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/jobs.vue